import { render, staticRenderFns } from "./Primaria.vue?vue&type=template&id=a59773f2&scoped=true"
import script from "./Primaria.vue?vue&type=script&lang=js"
export * from "./Primaria.vue?vue&type=script&lang=js"
import style0 from "./Primaria.vue?vue&type=style&index=0&id=a59773f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59773f2",
  null
  
)

export default component.exports